/**
 * 방금 만든 수납 거래 골라내기
 *
 * 왜 따로 있나:
 *   수납 등록 SP(CW_T_수납관리)는 만들어진 거래번호를 돌려주지 않는다. 그래서 등록한 뒤 목록을
 *   다시 읽어 "방금 그것" 을 찾아야 하고, 그 거래번호로 예약에 입금을 붙인다.
 *
 *   예전에는 날짜·금액·입금자로 찾았다. 같은 사람이 같은 날 같은 금액을 두 번 넣는 일은 실제로
 *   있어서, 그럴 때 예전 거래에 입금이 붙는다. 돈은 맞아도 어느 거래가 어디에 쓰였는지가 어긋나고,
 *   남은 잔액도 엉킨다.
 *
 *   그래서 등록 직전 거래번호를 찍어 두고 그 뒤에 새로 생긴 것만 후보로 본다.
 *   못 고르면 null 이다. 확신 없이 남의 거래에 붙이느니 사람이 화면에서 붙이는 게 낫다.
 */

/** 거래번호 집합을 만든다. 값이 없는 행은 버린다. */
export function toTxNoSet(rows) {
  return new Set(
    (Array.isArray(rows) ? rows : [])
      .map((r) => r?.거래번호)
      .filter((no) => no !== undefined && no !== null && String(no) !== '')
      .map(String)
  );
}

/**
 * @param {Set<string>} beforeTxNos 등록 직전에 있던 거래번호들
 * @param {Array} after             등록 후 다시 읽은 수납 목록
 * @param {string} date             수납일 YYYY-MM-DD
 * @param {number} amount           수납액
 * @param {string} depositor        입금자
 * @returns {object|null} 방금 만들어진 거래 행. 확신할 수 없으면 null.
 */
export function pickCreatedReceipt({ beforeTxNos, after, date, amount, depositor }) {
  const seen = beforeTxNos instanceof Set ? beforeTxNos : toTxNoSet(beforeTxNos);
  const fresh = (Array.isArray(after) ? after : []).filter((r) => {
    const no = r?.거래번호;
    if (no === undefined || no === null || String(no) === '') return false;
    return !seen.has(String(no));
  });

  if (fresh.length === 0) return null;
  if (fresh.length === 1) return fresh[0];

  // 등록하는 사이 다른 사람이 다른 건을 넣은 드문 경우다. 이때만 값으로 좁힌다.
  const matched = fresh.filter((r) => (
    String(r?.수납일 || '').includes(String(date))
    && Number(r?.수납액) === Number(amount)
    && String(r?.송급카드소유자 || '').includes(String(depositor))
  ));
  return matched.length === 1 ? matched[0] : null;
}
